import React, {Fragment} from 'react';
import {useDispatch, useSelector} from "react-redux";
import Select from "react-select";
import {editCellInSubmitForm, getRowData} from "../functions";
import _axios from "../../../../httpService";
import {v4 as uuidv4} from 'uuid';
import Options from "./Options";

function SelectMoienFormatter(props) {

  const sendData = useSelector(s => s.submitDocumentFormReducer)
  const dispatch = useDispatch();
  const uniqId = props.cell.getData().uniqId


  return (<select
    key={uuidv4()}
    className={'w-100'}
    value={props.cell.getData()[props.myKey]}
    onChange={(e) => props.handleChange(e, uniqId, props.myKey)}
    dir={'rtl'}
  >
    <option key={uuidv4()} value={""} hidden={true}>انتخاب کنید</option>

    {sendData?.documentPageData?.accounts && <Options
      accountsData={sendData.documentPageData.accounts}
    />}
    {/*{sendData?.documentPageData?.accounts?.map((v, index) => {*/}
    {/*  return <Fragment key={uuidv4()}>*/}
    {/*    <option key={uuidv4()} value={v.value}>{v.value}-{v.label}</option>*/}
    {/*  </Fragment>*/}
    {/*})}*/}
  </select>);
}

const MemoizedChildComponent = React.memo(SelectMoienFormatter);
export default MemoizedChildComponent




